import React from 'react'
import styled from 'styled-components'

import { m } from '../utils'

const StyledContainer = styled.div`
  width: 100%;
  padding: 1em 0;
  margin-top: 1em;
  display: flex;
`

const StyledDayName = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  color: #919191;
`

const Days = () => {
  const days = []

  for (let i = 0; i < 7; i++) {
    days.push(
      <StyledDayName key={i}>
        {m()
          .startOf('isoWeek')
          .add(i, 'day')
          .format('dd')
          .charAt(0)}
      </StyledDayName>
    )
  }
  return days
}

const WeekdayNames = () => (
  <StyledContainer>
    <Days />
  </StyledContainer>
)

export default WeekdayNames



// WEBPACK FOOTER //
// ./src/artzu-ui/src/Calendar/WeekdayNames.js